import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import Modal from 'react-bootstrap/Modal';
import { AnchorComponent, ButtonComponent } from "../elements";
import { useNavigate } from 'react-router-dom';

export default function VerifiedTableComponent({ thead, tbody, history, proceedTo = "/family-fund-forecast", maxSelect }) {
    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();
    const [alertModal, setAlertModal] = useState(false);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedFamilies, setSelectedFamilies] = useState([]);
    const itemsPerPage = 10;

    useEffect(() => {
        setData(tbody);
    }, [tbody]);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
        setCurrentPage(1);
    };

    const handleCheckboxChange = (id) => {
        setSelectedFamilies((prev) =>
            prev.includes(id) ? prev.filter((fid) => fid !== id) : [...prev, id]
        );
    };

    const handleSelectAll = (e) => {
        const currentPageIds = paginatedData.map(item => item.id);
        if (e.target.checked) {
            const newSelection = [...new Set([...selectedFamilies, ...currentPageIds])];
            setSelectedFamilies(newSelection);
        } else {
            const remaining = selectedFamilies.filter(id => !currentPageIds.includes(id));
            setSelectedFamilies(remaining);
        }
    };

    useEffect(() => {
        const selectAllCheckbox = document.querySelector(".mc-table-head input[type='checkbox']");
        if (selectAllCheckbox) {
            const currentPageIds = paginatedData.map(item => item.id);
            const allSelected = currentPageIds.every(id => selectedFamilies.includes(id));
            const noneSelected = currentPageIds.every(id => !selectedFamilies.includes(id));
            selectAllCheckbox.indeterminate = !allSelected && !noneSelected;
        }
    }, [selectedFamilies, data, currentPage]);

    const handleProceed = () => {
        if (selectedFamilies.length === 0) {
            alert("Please select at least one family.");
            return;
        }
        if (maxSelect !== undefined && selectedFamilies.length > maxSelect) {
            alert(`Only ${maxSelect} more families can be added to this request.`);
            return;
        }

        sessionStorage.setItem("selectedRows", JSON.stringify(selectedFamilies));
        navigate(proceedTo);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchQuery)
        )
    );

    const totalItems = filteredData.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const navigateToEdit = (id) => {
        navigate(`/edit-family/${id}`);
    };

    const navigateToVerify = (id) => {
        navigate(`/verify-family/${id}`);
    };

    return (
        <>
            <div className="mc-table-responsive">
                <div className="mc-search">
                    <input
                        type="text"
                        placeholder={t('search')}
                        value={searchQuery}
                        onChange={handleSearch}
                        className="form-control table-search"
                    />
                </div>

                <table className="mc-table product">
                    <thead className="mc-table-head"
                    style={{backgroundColor:"#077834",color:"#fff"}}>
                        <tr>
                            <th>
                                <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={paginatedData.length > 0 && paginatedData.every(item => selectedFamilies.includes(item.id))}
                                />
                            </th>
                            <th><div className="mc-table-check"><p>FSF-ID</p></div></th>
                            {thead.map((item, index) => (
                                <th key={index}>{t(item)}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                        {paginatedData.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedFamilies.includes(item.id)}
                                        onChange={() => handleCheckboxChange(item.id)}
                                    />
                                </td>
                                <td title={index + 1}>
                                    <div className="mc-table-check">
                                        <p>{item.fsf_id}</p>
                                    </div>
                                </td>
                                <td>
                                    <div className="mc-table-product md">
                                        <div className="mc-table-group">
                                            <h6>
                                                <p>{item.beneficiary_name}</p>
                                                <p>{item.beneficiary_cnic}</p>
                                            </h6>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <p>{item.partner_name}</p>
                                    <p>{item.organization_church}</p>
                                </td>
                                <td>{item.total_loan_amount}</td>
                               
                                <td>{item.status}</td>
                                <td>
                                    <div className="mc-table-action">
                                        <AnchorComponent to={`/family-report/${item.fsf_id}`} title="View" 
                                        style={{ backgroundColor: "rgba(7, 120, 52, 0.7)",color:"#fff"}}
className="material-icons view">
                                            {item.action.view}
                                        </AnchorComponent>
                                       
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="mc-table-footer text-end">
                <ButtonComponent
                    type="button"
                    className="btn btn-primary mt-3"
                    style={{backgroundColor:"#077834"}}
                    onClick={handleProceed}
                >
                    Proceed with Selected
                </ButtonComponent>
            </div>
  <div className="mc-paginate">
            <p className="mc-paginate-title">
                {t('showing')}
                <b> {startIndex + 1} </b>
                {t('to')}
                <b> {Math.min(startIndex + itemsPerPage, totalItems)} </b>
                {t('of')}
                <b> {totalItems} </b>
                {t('results')}
            </p>
            <ul className="mc-paginate-list">
               <li
  style={{
    color: "#077834",
    backgroundColor: "#e8f5e9", // default background
    borderRadius: "4px",
    padding: "5px 10px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#077834";
    e.currentTarget.style.color = "#fff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "#e8f5e9";
    e.currentTarget.style.color = "#077834";
  }}
  onClick={() => handlePageChange(currentPage - 1)}
>
  <i className="material-icons">chevron_left</i>
</li>

              	{[...Array(totalPages)].map((_, index) => {
						const isActive = index + 1 === currentPage;
						return (
							<li
								key={index}
								className="mc-paginate-item"
								style={{
									backgroundColor: isActive
										? "#077834"
										: "#e8f5e9",
									color: isActive ? "#fff" : "#077834",
									borderRadius: "4px",
									padding: "5px 10px",
									margin: "0 4px",
									cursor: "pointer",
									transition: "background-color 0.3s ease",
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.backgroundColor =
										"#06622a";
									e.currentTarget.style.color = "#fff";
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.backgroundColor =
										isActive ? "#077834" : "#e8f5e9";
									e.currentTarget.style.color = isActive
										? "#fff"
										: "#077834";
								}}
								onClick={() => handlePageChange(index + 1)}
							>
								{index + 1}
							</li>
						);
					})}
                <li
  style={{
    color: "#077834",
    backgroundColor: "#e8f5e9", 
    borderRadius: "4px",
    padding: "5px 10px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#077834";
    e.currentTarget.style.color = "#fff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "#e8f5e9";
    e.currentTarget.style.color = "#077834";
  }}
  onClick={() => handlePageChange(currentPage + 1)}
>
  <i className="material-icons">chevron_right</i>
</li>
            </ul>
        </div>


            <Modal show={alertModal} onHide={() => setAlertModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>Are you sure?</h3>
                    <p>Want to delete this product?</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setAlertModal(false)}>
                            {t('close')}
                        </ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={() => setAlertModal(false)}>
                            {t('delete')}
                        </ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
        </>
    );
}
